<template>
    <div v-if="detailInfo" class="detail-container">
        <div class="detail-content">
            <div class="row">
                <div class="col-md-7">
                    <label for="ptAddr">연결된 관제점</label>
                    <input type="text" class="form-control" id="ptAddr" disabled :value="detailInfo.ptAddr ?? '-'" />
                </div>
                <div class="col-md-2 p-0">
                    <label for="ptIdx">관제점 ID</label>
                    <input v-model="detailInfo.ptIdx" type="text" class="form-control" id="ptIdx" disabled />
                </div>
                <div class="col-md-3" style="display: flex; flex: 1; align-items: end; justify-content: end;">
                    <button
                        v-b-toggle.equipUserPropPtSearch
                        type="button"
                        class="btn btn-primary"
                        style="flex: 1;"
                        :disabled="!isEditMode"
                    >
                        관제점 선택
                    </button>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6 mt-2">
                    <label for="propCode">사용자 정의 속성</label>
                    <!-- <input v-model="detailInfo.propCode" type="text" class="form-control" id="propCode"
                        :disabled="!isEditMode"> -->
                    <valid-input
                        :vid="'사용자 정의 속성 코드'"
                        :classList="'form-control'"
                        :inputType="'text'"
                        :inputValue.sync="detailInfo.propCode"
                        :placeholder="$t('사용자 정의 속성 코드')"
                        :rules="rules.COMMON_CODE_RULE"
                        :errorMessage="validMessage.COMMON_CODE_VALID_MESSAGE"
                        :disabled="isDisabled"
                    ></valid-input>
                </div>
                <div class="form-group col-md-6 mt-2">
                    <label for="propName">사용자 정의 속성명</label>
                    <!-- <input v-model="detailInfo.propName" type="text" class="form-control" id="propName"
                        :disabled="!isEditMode"> -->
                    <valid-input
                        :vid="'사용자 정의 속성명'"
                        :classList="'form-control'"
                        :inputType="'text'"
                        :inputValue.sync="detailInfo.propName"
                        :placeholder="$t('사용자 정의 속성명')"
                        :rules="rules.COMMON_NAME_RULE"
                        :errorMessage="validMessage.COMMON_NAME_VALID_MESSAGE"
                        :disabled="isDisabled"
                    ></valid-input>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="unitType">단위 유형</label>
                    <select v-model="detailInfo.unitType" id="unitType" class="form-control" :disabled="isDisabled">
                        <option :value="null">선택</option>
                        <option v-for="(type, index) in $store.state.unitTypes" :key="index" :value="type.value">{{
                            type.text
                        }}</option>
                    </select>
                </div>
                <div class="form-group col-md-6">
                    <label for="unit">단위</label>
                    <select v-model="detailInfo.unit" id="unit" class="form-control" :disabled="isDisabled">
                        <option :value="null">선택</option>
                        <option
                            v-for="code in $store.state.unitCodes[detailInfo.unitType]"
                            :key="code.value"
                            :value="code.value"
                            id="unit"
                        >
                            {{ code.text }}
                        </option>
                    </select>
                </div>
                <!-- :disabled="!isEditMode || detailInfo.calcMethod !== 'Equip'" -->
                <div class="from-group col-md-12">
                    <label for="expression">사용자 정의값</label>
                    <!-- <textarea v-model="detailInfo.userValue" class="form-control" id="expression" rows="5"
                        style="resize: none;" :disabled="!isEditMode"></textarea> -->
                    <valid-textarea
                        :inputType="'text'"
                        :inputValue.sync="detailInfo.userValue"
                        :NonStatus="true"
                        :rows="5"
                        :classList="'desc-ctn form-control'"
                        :rules="rules.COMMON_DESC_RULE"
                        :disabled="isDisabled"
                    >
                    </valid-textarea>
                </div>
            </div>
        </div>
        <b-sidebar
            v-model="sideBar"
            ref="equipUserPropPtSearch"
            id="equipUserPropPtSearch"
            bg-variant="white"
            backdrop-variant="secondary"
            width="50vw"
            @hidden="closeSidebar"
            no-header
            shadow
            right
            backdrop
        >
            <div v-if="sideBar" style="padding: 1rem; height: 100%">
                <SearchComponent
                    :tableMaxHeight="'75vh'"
                    :optionTableHeight="'67vh'"
                    @select-point="selectPoint"
                    @close="closeSidebar"
                />
            </div>
        </b-sidebar>
    </div>
</template>

<script>
import * as rules from "@src/consts/ruleConsts.js";
import * as validMessage from "@src/consts/validMessageConsts.js";
// import backEndApi from '@src/api/backEndApi';
import SearchComponent from "@src/views/component/v2.1/PointSearch/Search.vue";

export default {
    components: {
        SearchComponent,
    },
    props: ["mode", "registType"],
    data() {
        return {
            detailInfo: null,
            sideBar: false,
            rules,
            validMessage,
        };
    },
    watch: {},
    computed: {
        isEditMode() {
            return this.mode !== "view";
        },
        isDisabled() {
            return !this.isEditMode || this.registType === "edit";
        },
    },
    created() {},
    mounted() {},
    destroyed() {},
    methods: {
        showSideBar() {
            this.sideBar = true;
        },
        closeSidebar() {
            this.$refs.equipUserPropPtSearch.hide();
            this.sideBar = false;
        },
        initData() {
            return {
                propCode: null,
                propName: null,
                dataSourceType: "User",
                ptIdx: null,
                userValue: null,
                enabled: "Y",
                ptAddr: null,
                unitType: null,
                unit: null,
            };
        },
        setData(data) {
            if (data) {
                this.detailInfo = data;
            } else {
                this.detailInfo = this.initData();
            }
            // else return;
        },
        getData() {
            return this.detailInfo;
        },
        async selectPoint(data) {
            if (data) {
                this.detailInfo.ptIdx = data.ptIdx ? data.ptIdx : "-";
                this.detailInfo.ptAddr = data.ptAddr ? data.ptAddr : "-";
                this.detailInfo.unitType = data.unitLargeCode ? data.unitLargeCode : null;
                this.detailInfo.unit = data.unitSmallCode !== "" && data.unitSmallCode ? data.unitSmallCode : null;
            }
            await this.$refs.equipUserPropPtSearch.hide();
        },
    },
};
</script>

<style scoped>
.detail-container {
    height: 100%;
    /* height: 400px; */
    /* width: 100%; */
    /* border-radius: 8px; */
    /* border: solid #eee 1px; */
    /* background-color: white; */
    font-size: 12px;
}

.detail-placeholder {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.detail-header {
    background-color: #fff;
    border-radius: 8px 8px 0px 0px;
    padding: 0.8rem 1rem;
    /* margin: 1rem 0rem; */
}

.detail-content {
    height: 100%;
    width: 100%;
    /* border-radius: 0px 0px 8px 8px; */
    /* border: solid #eee 1px; */
    /* padding: 1rem 1rem; */
    /* overflow-y: auto; */
}

.detail-bottom {
    display: flex;
    justify-content: space-between;
}

.btn-sm {
    height: 1.4rem !important;
    line-height: 0.9 !important;
}
</style>
